/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GetFinaSettings200,
  UpdateFinaSettings200,
  UpdateFinaSettingsBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve CIS fiscalization settings for the entity, including certificate status and configuration
 * @summary Get FINA settings
 */
export type getFinaSettingsResponse200 = {
  data: GetFinaSettings200
  status: 200
}

export type getFinaSettingsResponse400 = {
  data: Error
  status: 400
}

export type getFinaSettingsResponse401 = {
  data: Error
  status: 401
}

export type getFinaSettingsResponse403 = {
  data: Error
  status: 403
}

export type getFinaSettingsResponse404 = {
  data: Error
  status: 404
}

export type getFinaSettingsResponse500 = {
  data: Error
  status: 500
}

export type getFinaSettingsResponseSuccess = (getFinaSettingsResponse200) & {
  headers: Headers;
};
export type getFinaSettingsResponseError = (getFinaSettingsResponse400 | getFinaSettingsResponse401 | getFinaSettingsResponse403 | getFinaSettingsResponse404 | getFinaSettingsResponse500) & {
  headers: Headers;
};

export type getFinaSettingsResponse = (getFinaSettingsResponseSuccess | getFinaSettingsResponseError)

export const getGetFinaSettingsUrl = () => {


  

  return `/fiscalization/fina/settings`
}

export const getFinaSettings = async ( options?: RequestInit): Promise<getFinaSettingsResponse> => {
  
  return customFetch<getFinaSettingsResponse>(getGetFinaSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update CIS fiscalization settings for the entity. Certificate must be uploaded separately via POST /fiscalization/fina/settings/certificate
 * @summary Update FINA settings
 */
export type updateFinaSettingsResponse200 = {
  data: UpdateFinaSettings200
  status: 200
}

export type updateFinaSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateFinaSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateFinaSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateFinaSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateFinaSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateFinaSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateFinaSettingsResponseSuccess = (updateFinaSettingsResponse200) & {
  headers: Headers;
};
export type updateFinaSettingsResponseError = (updateFinaSettingsResponse400 | updateFinaSettingsResponse401 | updateFinaSettingsResponse403 | updateFinaSettingsResponse404 | updateFinaSettingsResponse422 | updateFinaSettingsResponse500) & {
  headers: Headers;
};

export type updateFinaSettingsResponse = (updateFinaSettingsResponseSuccess | updateFinaSettingsResponseError)

export const getUpdateFinaSettingsUrl = () => {


  

  return `/fiscalization/fina/settings`
}

export const updateFinaSettings = async (updateFinaSettingsBody: UpdateFinaSettingsBody, options?: RequestInit): Promise<updateFinaSettingsResponse> => {
  
  return customFetch<updateFinaSettingsResponse>(getUpdateFinaSettingsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateFinaSettingsBody,)
  }
);}
  

